<div class="row nav-container">
    <a class="btn btn-default" (click)="selectPreviousWeek()">
        <i class="fa fa-angle-left"></i>
    </a>

    <div class="current-week">{{weekStartLabel}} - {{weekEndLabel}}</div>

    <a class="btn btn-default" (click)="selectNextWeek()">
        <i class="fa fa-angle-right"></i>
    </a>

    <input class="form-control" placeholder="yyyy-mm-dd"
           name="dp" #d="ngbDatepicker" ngbDatepicker
           [(ngModel)]="datePickerDate" (ngModelChange)="datePickerDateChange($event)">
    <button class="btn btn-default" (click)="d.toggle()" type="button">
        <i class="fa fa-calendar"></i>
    </button>
</div>


// WEBPACK FOOTER //
// ./src/app/_screens/session/calendar/date/date.component.html